import axios from '../../axios';
import { toast } from 'react-toastify';
import { ADD_UQC, UPDATE_UQC, GET_UQC, GET_ALL_UQC, DELETE_UQC } from '../types';

export const getUnit = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/uqc/all`, { params });

      if (res.data.code === 1) {
         dispatch({ type: GET_ALL_UQC, payload: res.data.data });
      }
   } catch (err) {
      if (err.response?.data.message) {
         toast.error(err.response?.data.message);
      }
      // console.error('Failed to add Unit. Please try again. :', err);
   }
};

export const addUnit = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`${process.env.REACT_APP_BASEURL}/uqc/add`, formData);

      if (res.data.code === 1) {
         dispatch({ type: ADD_UQC, payload: res.data.data });
         setTimeout(() => {
            toast.success('UQC added successfully!');
         }, 1000);
      }
      if (res.data.code === 0) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
      // toast.error('Failed to add Unit. Please try again. :', err);
   }
};

export const updateUnit = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/uqc/update`, formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_UQC, payload: res.data.data });

         setTimeout(() => {
            toast.success('UQC updated successfully!');
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
      // toast.error('Failed to update Unit. Please try again.');
   }
};

// Delete Unit
export const deleteUnit = (id) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/uqc/delete/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_UQC, payload: { id } });
         setTimeout(() => {
            toast.success('UQC deleted successfully!');
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
      // toast.error('Failed to delete Unit. Please try again.');
   }
};
